// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ActorTypeSchema = z.enum(['USER','AUTOMATION'] as const);

export type ActorTypeType = `${z.infer<typeof ActorTypeSchema>}`

export default ActorTypeSchema;
